import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/button.css';

const Button = ({ label, bgColor, color, borderColor, path }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (path) {
            navigate(path);
        }
    };

    return (
        <button
            style={{
                backgroundColor: bgColor,
                color: color,
                borderColor: borderColor,
                borderWidth: '1px',
                borderStyle: 'solid',
                padding: '10px 20px',
                cursor: 'pointer',
            }}
            className='container-button'
            onClick={handleClick}
        >
            {label}
        </button>
    );
};

export default Button;